(() => {
  const rootId = 'pplr-10813898457253';
  const set = (element, name, value) => {
    if (element.getAttribute(name) !== value) element.setAttribute(name, value);
  };
  const allowZoom = () => {
    const viewport = document.getElementById('pplr_meta');
    if (viewport) set(viewport, 'content', 'width=device-width, initial-scale=1.0');
  };
  const enhance = () => {
    allowZoom();
    const root = document.getElementById(rootId);
    if (!root) return;
    root.querySelectorAll('.pplr-swatch-element[data-val]').forEach((swatch) => {
      set(swatch, 'role', 'button');
      set(swatch, 'tabindex', '0');
      set(swatch, 'aria-label', swatch.getAttribute('data-val'));
      set(swatch, 'aria-pressed', String(swatch.classList.contains('selected')));
      if (!swatch.dataset.ahKeyboard) {
        swatch.dataset.ahKeyboard = 'true';
        swatch.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            swatch.click();
          }
        });
      }
    });
    root.querySelectorAll('textarea[name]').forEach((field) => {
      const label = field.name.replace(/^properties\[/, '').replace(/\]$/, '');
      set(field, 'aria-label', label);
      const help = field.closest('.pplr-wrapper')?.querySelector('.ptooltiptext');
      if (help) {
        set(help, 'id', 'ah-notepad-notes-help');
        set(field, 'aria-describedby', help.id);
      }
    });
  };
  let scheduled = false;
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      enhance();
    });
  };
  const start = () => {
    enhance();
    const observeRoot = () => {
      const root = document.getElementById(rootId);
      if (!root) return false;
      new MutationObserver(schedule).observe(root, {
        childList: true, subtree: true, attributes: true, attributeFilter: ['class']
      });
      enhance();
      return true;
    };
    if (!observeRoot()) {
      const pending = new MutationObserver(() => {
        if (observeRoot()) pending.disconnect();
      });
      pending.observe(document.body, { childList: true, subtree: true });
    }
    new MutationObserver(allowZoom).observe(document.head, {
      childList: true, subtree: true, attributes: true, attributeFilter: ['content']
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
